export const ACTION_IDS = {
  CREATE_TASK: 'create-task',
  EDIT: 'edit',
  EDIT_GOALS: 'edit-goals',
  DELETE: 'delete',
  MANAGE_ACCESS: 'manage-access',
  TRACKING_URL: 'tracking-url',
  COMPARE: 'compare',
  COMMENT: 'comment',
  EXPORT: 'export'
};